import { render } from "./pediatrics_diagnosis.vue?vue&type=template&id=13ea976b&scoped=true"
import script from "./pediatrics_diagnosis.vue?vue&type=script&lang=js"
export * from "./pediatrics_diagnosis.vue?vue&type=script&lang=js"

import "./pediatrics_diagnosis.vue?vue&type=style&index=0&id=13ea976b&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ea976b"]])

export default __exports__